import request from '@/utils/request'

/**
 * 获取场景分类列表
 */
export function getClassifyList() {
  return request.get('/app/classify/classifyList', {}, { token: false })
}

/**
 * 获取模型列表
 * @param {Object} params 可选筛选参数（如关键词、价格范围等）
 * @returns {Promise}
 */
export function getModelList(params = {}) {
  // 模型列表通常为公开数据，这里默认不携带 token
  return request.get('/app/model/modelList', params, { token: false })
}

/**
 * 获取模型详情
 * @param {string} id 模型ID
 * @returns {Promise}
 * 支持未登录访问（Token 可选）
 */
export function getModelDetail(id) {
  return request.get(`/app/model/modelDetail`, { modelId: id })
}

/**
 * 记录模型浏览
 * @param {number} modelId 模型ID
 * @returns {Promise}
 */
export function recordModelView(modelId) {
  return request.post('/app/content/view', { contentId: modelId, contentType: 'model' }, { token: false })
}

/**
 * 提交发布模型
 * @param {Object} data 模型数据
 * @returns {Promise}
 */
export function addModel(data) {
  return request.post('/app/model/addModel', data)
}
